// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__32MKH","productName":"Table_productName__4HMNO"};